<div class="image-hint">
    <img class="image" [src]="url" />
</div>
